export default "__VITE_ASSET__7a6f4bf3__"